import { requestGet as wsRequestGet, requestPost as wsRequestPost } from './_wsApiFetchData';
import { weekdays } from '../enums/weekdays';


export async function sendConfirmationEmail(id, onlyPreview, language, timeZone, cancelToken) {
  return wsRequestPost('/admin/SeasonalCourts/Purchase/SendConfirmationEmail', language, timeZone, {
    SeasonalCourtPurchaseId: id,
    OnlyGetPreview: onlyPreview 
  }, {}, cancelToken);
}

export async function book(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/SeasonalCourts/book-seasonal-court-purchase`, language, timeZone, {
    id
  }, cancelToken);
}

export async function getCourtsStatus(language, timeZone, cancelToken) {
  return wsRequestGet('/admin/SeasonalCourts/GetCourtsStatusJson', language, timeZone, {}, cancelToken);
}

export async function createWallet(id, onlyPreview, language, timeZone, cancelToken) {
  return wsRequestPost('/admin/Users/Wallet/Create', language, timeZone, {
    UserId: id
  }, {}, cancelToken);
}

// `note` is optional (null for none); it is kept in the wallet history with the admin's name.
export async function setWallet(id, amount, note, language, timeZone, cancelToken) {
  return wsRequestPost('/admin/Users/Wallet/SetAmount', language, timeZone, {
    UserId: id,
    Amount: amount,
    Note: note || null
  }, {}, cancelToken);
}

export async function searchPurchases(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const params = Object.assign({
    'page': skipPages || 1,
    'count': resultsCount
  }, filters);

  return toPascal(await wsRequestGet('/admin/SeasonalCourts/purchases/search', language, timeZone, params, cancelToken));
}

export async function searchCourts(options, language, timeZone, cancelToken) {
  const { filters, skipPages, resultsCount } = options;
  const WeekDay = filters && filters.WeekDay ? weekdays[filters.WeekDay] : null;

  const params = Object.assign({
    'Page': skipPages || 1,
    'Count': resultsCount
  }, Object.assign(filters, { WeekDay }));

  return toPascal(await wsRequestGet('/admin/SeasonalCourts/search', language, timeZone, params, cancelToken));
}

export async function getReport(options, language, timeZone, cancelToken) {
  const { year, month } = options;

  let wsApiResult = await wsRequestGet(`/admin/SeasonalCourts/SeasonalCourtReportCvs`, language, timeZone, {
    year, month
  }, cancelToken);

  return wsApiResult;
}

export async function getSlot(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/SeasonalCourts/Slot/${id}`, language, timeZone, null, cancelToken));
}

export async function getPurchase(id, language, timeZone, cancelToken) {
  let wsApiResult = await wsRequestGet(`/admin/SeasonalCourts/GetSeasonalCourtPurchaseDetails`, language, timeZone, {
    SeasonalCourtPurchaseId: id
  }, cancelToken);

  return wsApiResult;
}

export async function getCourt(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/SeasonalCourts/court/${id}`, language, timeZone, null, cancelToken);
}

export async function getCourtWithDetails(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/SeasonalCourts/court-details/${id}`, language, timeZone, null, cancelToken));
}

export async function reserveFromPurchase(courtId, purchaseId, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/SeasonalCourts/reservefrompurchase/${courtId}/${purchaseId}`, language, timeZone, {}, {}, cancelToken);
}

export async function cancelslot(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/SeasonalCourts/cancelslot/${id}`, language, timeZone, {}, cancelToken);
}

// `cancelSlotsFrom` is a Copenhagen day (YYYY-MM-DD): the slots from that day on
// are cancelled, the earlier ones kept. The backend falls back to its own default
// (the first of next month) when it is missing — which is why the dialogs always
// show and send it explicitly.
export async function cancel(id, cancelSlotsFrom, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/SeasonalCourts/cancel/${id}`, language, timeZone, {
    cancelSlotsFrom
  }, cancelToken);
}

export async function changeCourtOptions(id, language, timeZone, cancelToken) {
  return wsRequestGet(`/admin/SeasonalCourts/change-court-options/${id}`, language, timeZone, null, cancelToken);
}

// `moveFrom` is a Copenhagen day (YYYY-MM-DD). `dryRun` only returns the plan.
export async function changeCourt(id, newCourtId, moveFrom, dryRun, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/SeasonalCourts/change-court/${id}`, language, timeZone, {}, {
    newCourtId,
    moveFrom,
    dryRun: !!dryRun
  }, cancelToken);
}

export async function integrate(id, language, timeZone, cancelToken) {
  return wsRequestPost(`/admin/SeasonalCourts/IntegrateCourt/${id}`, language, timeZone, {}, null, cancelToken);
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
